import { render, staticRenderFns } from "./tags-field.vue?vue&type=template&id=3edd2554&"
import script from "./tags-field.vue?vue&type=script&lang=js&"
export * from "./tags-field.vue?vue&type=script&lang=js&"
import style0 from "./tags-field.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3edd2554')) {
      api.createRecord('3edd2554', component.options)
    } else {
      api.reload('3edd2554', component.options)
    }
    module.hot.accept("./tags-field.vue?vue&type=template&id=3edd2554&", function () {
      api.rerender('3edd2554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tags-field.vue"
export default component.exports